import { render, staticRenderFns } from "./TrashContactHistorical.vue?vue&type=template&id=1f36d04c&scoped=true"
import script from "./TrashContactHistorical.vue?vue&type=script&lang=js"
export * from "./TrashContactHistorical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f36d04c",
  null
  
)

export default component.exports